import { DE_LOCALE } from '@core/Constants/Locale.constants';
import { mappedLocales } from '@core/Utils/Intl/MappedLocales';

import { getPsFromKw } from '@core/Utils/SearchFilters/GetPsFromKw';
import Button from '@gds/Button/Button';
import { Input } from '@gds/Input/Input';
import Slider from '@gds/Slider/Slider';
import { Typography } from '@gds/Typography/Typography';

import { useRangeFilters } from 'Hooks/SearchFilters/UseRangeFilters';

import { FilterControlBaseProps } from '../../FilterPanel.entity';

import { ENGINE_POWER_RANGE } from './PowerFilter.constants';

import styles from './PowerFilter.module.css';

type PowerFilterProps = FilterControlBaseProps;

export const PowerFilter = ({ strings, locale }: PowerFilterProps) => {
  const minVal = ENGINE_POWER_RANGE[locale][0].toString();
  const maxVal = ENGINE_POWER_RANGE[locale][ENGINE_POWER_RANGE[locale].length - 1].toString();
  const isDe = locale === DE_LOCALE;
  const { gteInputProps, lteInputProps, sliderProps, canReset, reset, totalCount } =
    useRangeFilters('engine-power', ENGINE_POWER_RANGE[locale], [minVal, maxVal], undefined);

  return (
    <section className={styles.powerFilter}>
      <div className={styles.minMaxInputs}>
        <Input
          {...gteInputProps}
          label={strings.min}
          type="number"
          min={0}
          name="min-power"
          rightIcon={isDe && <>{strings.kw}</>}
        />
        <Input
          {...lteInputProps}
          label={strings.max}
          type="number"
          max={maxVal}
          name="max-power"
          rightIcon={isDe && <>{strings.kw}</>}
        />
      </div>
      {isDe && (
        <div className={styles.alternateUnits}>
          <div className={styles.resultCount}>{`( ${getPsFromKw(
            Number(gteInputProps.value),
          )} PS)`}</div>
          <div className={styles.resultCount}>{`( ${getPsFromKw(
            Number(lteInputProps.value),
          )} PS)`}</div>
        </div>
      )}
      <div className={styles.auxInfo}>
        <Typography Component="span" className={styles.resultCount} variant="caption2">
          ({totalCount.toLocaleString(mappedLocales[locale])})
        </Typography>
        <Button
          color="secondary"
          name="reset"
          disabled={!canReset()}
          onClick={() => reset()}
          size="small"
          variant="link"
        >
          {strings.reset}
        </Button>
      </div>
      <Slider {...sliderProps} dataTestId="power-slider" />
    </section>
  );
};
